export const getFullAbbreviation = sty => {
  return `${sty.sectionAbbreviation} (${sty.schoolYearName})`
}

export const getFullName = sty => {
  return `${sty.sectionName} (${sty.schoolYearName})`
}

export const reduceBySection = sectionToYears => sectionToYears.reduce(
  (acc, sty) => {
    const sectionId = sty.section === null ? -1 : sty.section.id

    if (!acc[sectionId]) {
      acc[sectionId] = []
    }

    acc[sectionId].push(sty)

    return acc
  }, {}
)